import React from "react";
import { Modal, Typography } from 'antd';
const { Paragraph } = Typography;

function TermsModal({ visible, setVisible }){

    return(
        <Modal
            title="Termos e Condições"
            visible={visible}
            onOk={() => setVisible(visible = false)}
            onCancel={() => setVisible(visible = false)}
        >
            <Paragraph>
                Os termos e condições de uso que regulamentam a ferramenta que pertence à Organização Sorocabana Seol Empreendimentos de Luto Ltda., 
                CNPJ/MF nº 57.051.120/0001-35, com sede na Rua Dr. Álvaro Guião, 193 – Vila Assis, Sorocaba, estado de São Paulo, são os seguintes:
            </Paragraph>

            <Paragraph>
                <ul>
                    <li>
                        <Paragraph>
                            O A detentora oferece ao Usuário através de <strong>“voucher”</strong> (login e senha), o acesso ao seu site, 
                            o qual permite a visualização a distância de velório que se dará em suas instalações;
                        </Paragraph>
                    </li>
                    <li>
                        <Paragraph>
                            O tempo de duração do <strong>“voucher”</strong> é limitado e fica a cargo da detentora da ferramenta a determinação do horário de expiração 
                            da autorização de visualização, podendo esta ser interrompida a qualquer tempo por parte daquela sem prévia notificação do usuário;
                        </Paragraph>
                    </li>
                    <li>
                        <Paragraph>
                            Os procedimentos necessários para a utilização da ferramenta foram devidamente fornecidos pela 
                            empresa detentora através de seus funcionários no ato da contratação dos serviços funerários;
                        </Paragraph>
                    </li>
                    <li>
                        <Paragraph>
                            A detentora não se responsabiliza por quaisquer danos sofridos pelo Usuário ou terceiros que, de qualquer modo, 
                            tenha origem ou dependência relacionada à Ferramenta;
                        </Paragraph>
                    </li>
                    <li>
                        <Paragraph>
                            Exime-se a detentora de quaisquer responsabilidades sobre qualquer interrupção ou erro em seu site, 
                            incluindo a impossibilidade de acessa-lo por motivos de manutenção, queda do serviço e outros problemas que possam 
                            eventualmente ocorrer no acesso à rede de internet;
                        </Paragraph>
                    </li>
                    <li>
                        <Paragraph>
                            O Usuário da ferramenta se declara estar ciente de que pode vir a ser responsabilizado por danos morais, 
                            materiais e criminais decorrentes da utilização, reprodução ou divulgação indevida das referidas imagens, 
                            com base na Constituição Federal, Código Civil, Código Penal e demais dispositivos legais que garantem o direito de proteção à imagem.
                        </Paragraph>
                    </li>
                </ul>
            </Paragraph>

        </Modal>
    )
}

export default TermsModal;


// WEBPACK FOOTER //
// ./src/components/general/voucherWrapper/components/TermsModal.jsx